var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 8c.725.012 1.769-.913 2.294-1.294 4.147-3.01 4.462-3.272 5.418-4.022a.748.748 0 00.288-.59V1.5A1.5 1.5 0 0014.5 0h-13A1.5 1.5 0 000 1.5v.594c0 .231.106.447.288.59.956.747 1.271 1.013 5.418 4.022C6.231 7.087 7.275 8.012 8 8zm6.5 4a1.5 1.5 0 001.5-1.5V4.11a.188.188 0 00-.303-.148c-.7.544-1.625 1.238-4.813 3.554C10.25 7.978 9.116 9.012 8 9.003c-1.11.006-2.222-1.006-2.881-1.487C1.93 5.2 1.003 4.509.303 3.966A.187.187 0 000 4.112V10.5A1.5 1.5 0 001.5 12h13z","fillRule":"evenodd"}));
}

Mail.defaultProps = {"viewBox":"0 0 16 12"};

module.exports = Mail;

Mail.default = Mail;
